import DevExpress from 'devextreme';

/** default settings for DX text box */
export const dxTextBoxDefaults: DevExpress.ui.dxTextBoxOptions<any> = {
	inputAttr: {
		'data-lpignore': true,
	},
};
